import React, {
  createContext,
  useCallback,
  useContext,
  useReducer,
} from "react";

import dfSubDays from "date-fns/subDays";

import { formatDate, getDateByTimeZone } from "@/lib/date";

import DeliveryCollectedLog from "@/Models/DeliveryCollectedLog";
import api from "../Api";

const CONSTANTS = {
  FETCH_ALL: "FETCH_ALL",
  SET_QUERY: "SET_QUERY",
};

const zonedDateYesterday = dfSubDays(getDateByTimeZone(), 1);
const zonedDateToday = getDateByTimeZone();
const initDateFrom = formatDate(zonedDateYesterday);
const initDateTo = formatDate(zonedDateToday);

const INITIAL_QUERY = {
  dateFrom: initDateFrom,
  dateTo: initDateTo,
  page: 1,
  pageSize: 20,
  bookIdOrOrderIdFromCorp: "",
  region: "",
  senderName: "",
  sortKey: "receiptDate",
  sortType: "DESC",
  mainOffice: true, // 본사 확인
};

const INITIAL_STATE = {
  deliveriesCollected: [],
  totalCount: 0,
  pageCount: 0,
  query: INITIAL_QUERY,
};

const reducer = (state, action) => {
  switch (action.type) {
    case CONSTANTS.FETCH_ALL:
      return {
        ...state,
        deliveriesCollected: action.deliveriesCollected,
        totalCount: action.totalCount,
        pageCount: action.pageCount,
      };
    case CONSTANTS.SET_QUERY:
      return {
        ...state,
        query: {
          ...state.query,
          ...action.query,
        },
      };
    default:
      return INITIAL_STATE;
  }
};

export const Context = createContext(INITIAL_STATE);

export const Provider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);

  return (
    <Context.Provider value={{ dispatch, state }}>{children}</Context.Provider>
  );
};

export const useDeliveriesCollectedStore = () => {
  const { dispatch, state } = useContext(Context);

  const fetchAll = useCallback(async () => {
    let query = {
      ...state.query,
    };

    const { rows, totalCount } = await api.get("/deliveries/collected", query);

    dispatch({
      type: CONSTANTS.FETCH_ALL,
      deliveriesCollected: rows.map((d) => new DeliveryCollectedLog(d)),
      totalCount,
      pageCount:
        Math.floor(totalCount / state.query.pageSize) +
        (totalCount % state.query.pageSize ? 1 : 0),
    });
  }, [dispatch, state.query]);

  const setQuery = useCallback(
    (query = {}) => {
      dispatch({ type: CONSTANTS.SET_QUERY, query });
    },
    [dispatch],
  );

  return {
    state,
    fetchAll,
    setQuery,
  };
};
